import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Auth } from "aws-amplify";
import { Button, TextField, Alert, CircularProgress } from "@mui/material";
import "../../styles/login.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const role = searchParams.get("role") || "buyer";

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      await Auth.forgotPassword(email);
      setMessage(
        "Verification code sent to your email. Please check your inbox."
      );

      // Redirect to reset password page with email and role
      setTimeout(() => {
        navigate(
          `/reset-password?email=${encodeURIComponent(email)}&role=${role}`
        );
      }, 2000);
    } catch (err) {
      console.error("Forgot password error:", err);
      setError(
        err.message || "Failed to send verification code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-password">
      <div className="password-form card">
        <form onSubmit={handleSubmit}>
          <div>
            <h1>Reset Password</h1>
            <p className="text-muted text-center" style={{ fontSize: "0.9rem" }}>
              Enter your email address and we'll send you a verification code to
              reset your password.
            </p>
          </div>

          {error && (
            <Alert severity="error" style={{ marginBottom: "20px" }}>
              {error}
            </Alert>
          )}

          {message && (
            <Alert severity="success" style={{ marginBottom: "20px" }}>
              {message}
            </Alert>
          )}

          <div>
            <label htmlFor="email">Email Address</label>
            <TextField
              type="email"
              id="email"
              fullWidth
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              style={{ marginBottom: "20px" }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                backgroundColor: "#de6b14",
                color: "white",
                "&:hover": {
                  backgroundColor: "#c55a11",
                },
                "&:disabled": {
                  backgroundColor: "#ccc",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send Verification Code"
              )}
            </Button>
          </div>

          <div className="text-center">
            <Button
              variant="text"
              onClick={() => navigate(`/login/${role}`)}
              sx={{
                color: "#333 !important",
                textTransform: "none",
                fontWeight: "500",
                "&:hover": {
                  color: "#de6b14",
                  backgroundColor: "rgba(222, 107, 20, 0.04)",
                },
              }}
            >
              Back to Login
            </Button>
          </div>
        </form>
      </div>

    </div>
  );
};

export default ForgotPassword;
